/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { Library } from '../../Library';
import { AbstractCommand } from '../AbstractCommand';
import { LoggerCompat } from '../../compat/LoggerCompat';
import { Document } from '../../core/models/Document';
import { NodePath } from '../../core/models/NodePath';
import { Oas30Example } from '../../openapi/v3/models/Oas30Example';
import { Oas30MediaType } from '../../openapi/v3/models/Oas30MediaType';

/**
 * A command used to delete a single mediaType from an operation.
 * @author eric.wittmann@gmail.com
 * @extends AbstractCommand
 * @class
 */
export class DeleteAllExamplesCommand extends AbstractCommand {
    public _mediaTypePath : NodePath;

    public _oldExamples : any;

    public constructor(mediaType? : any) {
        if(((mediaType != null && mediaType instanceof <any>Oas30MediaType) || mediaType === null)) {
            let __args = arguments;
            super();
            if(this._mediaTypePath===undefined) this._mediaTypePath = null;
            if(this._oldExamples===undefined) this._oldExamples = null;
            if(this._mediaTypePath===undefined) this._mediaTypePath = null;
            if(this._oldExamples===undefined) this._oldExamples = null;
            (() => {
                this._mediaTypePath = Library.createNodePath(mediaType);
            })();
        } else if(mediaType === undefined) {
            let __args = arguments;
            super();
            if(this._mediaTypePath===undefined) this._mediaTypePath = null;
            if(this._oldExamples===undefined) this._oldExamples = null;
            if(this._mediaTypePath===undefined) this._mediaTypePath = null;
            if(this._oldExamples===undefined) this._oldExamples = null;
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#execute(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public execute(document : Document) {
        LoggerCompat.info("[DeleteAllExamplesCommand] Executing.");
        if(this.isNullOrUndefined(document)) {
            LoggerCompat.debug("[DeleteAllExamplesCommand] Could not execute the command, invalid argument.");
            return;
        }
        if(this.isNullOrUndefined(this._mediaTypePath)) {
            LoggerCompat.debug("[DeleteAllExamplesCommand] Could not execute the command, problem when unmarshalling.");
            return;
        }
        let mediaType : Oas30MediaType = <Oas30MediaType>this._mediaTypePath.resolve(document);
        if(this.isNullOrUndefined(mediaType)) {
            LoggerCompat.debug("[DeleteAllExamplesCommand] Media type not found.");
            return;
        }
        this._oldExamples = <any>({});
        mediaType.getExamples().forEach((e) => {
            /* put */(this._oldExamples[e.getName()] = Library.writeNode(e));
        });
        mediaType.examples = <any>({});
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#undo(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public undo(document : Document) {
        if(this.isNullOrUndefined(document)) {
            LoggerCompat.debug("[DeleteAllExamplesCommand] Could not revert the command, invalid argument.");
            return;
        }
        if(this.isNullOrUndefined(this._mediaTypePath)) {
            LoggerCompat.debug("[DeleteAllExamplesCommand] Could not revert the command, problem when unmarshalling.");
            return;
        }
        LoggerCompat.info("[DeleteAllExamplesCommand] Reverting.");
        let mediaType : Oas30MediaType = <Oas30MediaType>this._mediaTypePath.resolve(document);
        if(this.isNullOrUndefined(mediaType)) {
            LoggerCompat.info("[DeleteAllExamplesCommand] No media type found.");
            return;
        }
        if(this.isNullOrUndefined(this._oldExamples)) {
            LoggerCompat.info("[DeleteAllExamplesCommand] Could not revert. Previous data is not available.");
            return;
        }
        {
            let array216 = /* keySet */Object.keys(this._oldExamples);
            for(let index215=0; index215 < array216.length; index215++) {
                let k = array216[index215];
                {
                    let example : Oas30Example = mediaType.createExample(k);
                    Library.readNode(/* get */((m,k) => m[k]===undefined?null:m[k])(this._oldExamples, k), example);
                    mediaType.addExample(example);
                }
            }
        }
    }
}
DeleteAllExamplesCommand["__class"] = "io.apicurio.datamodels.cmd.commands.DeleteAllExamplesCommand";
DeleteAllExamplesCommand["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];





import { MarshallCompat } from '../../compat/MarshallCompat';

